// Predicates
import { format, formatDuration as formatDurationFn, intervalToDuration } from 'date-fns'

export const nonNull = value => value != null
export const distinct = (item, index, array) => array.indexOf(item) === index
export const duplicate = (item, index, array) => array.indexOf(item) !== index

// String
export const trimEndingSlashes = string => {
  while (string && string.endsWith('/')) {
    string = string.substring(0, string.length - 1)
  }
  return string
}

// Math
export const sum = (...values) => values.reduce((acc, value) => acc + value, 0)
export const avg = (a, b) => (a + b) / 2

export const toSignificantDigits = (digits, value) =>
  digits ? Number(Number(value).toPrecision(digits)) : value

export const finiteOrNull = num => isFinite(num) ? num : null

// Date, time
export const formatDateTimeShort = value => value ? format(value, 'Pp') : ''
export const formatDateTimeLong = value => value ? format(value, 'PPpp') : ''

export const formatDurationBetweenTimes = (start, end) =>
  start && end ? formatDurationFn(intervalToDuration({ start, end })) : ''

export const formatDurationOfMillis = millis => {
  const start = new Date().valueOf()
  const end = start + millis
  return millis != null ? formatDurationFn(intervalToDuration({ start, end })) : ''
}

const minute = 1_000 * 60
export const roundMillisToMinutes = millis => Math.round(millis / minute) * minute
